import theme from "assets/styles/themes";
import { TMoreOptions } from "components/Projection/ProjectionBody/chartsListConfig";
import { WATERMARK } from "constants/chartCommons";
import { LD9Chart } from "store/slice/charts";
import { drawButtons } from "./bridge.functions";

type TGetOption = (chartDataState: LD9Chart, moreOptions?: TMoreOptions) => any;

export const getOption: TGetOption = (chartDataState, moreOptions) => {
    return {
        credits: {
            text: WATERMARK,
            href: "#",
            position: {
                align: "left",
            },
            style: {
                fontSize: "8px",
            },
        },
        chart: {
            animation: false,
            type: "waterfall",
            className: "BridgeChart",
            marginBottom: 150,
            style: {
                fontFamily: "Lato, sans-serif",
            },
            events: {
                redraw: function (this) {
                    drawButtons(this as Highcharts.Chart, chartDataState, moreOptions);
                },
            },
        },
        title: {
            text: undefined,
        },
        xAxis: {
            type: "category",
            lineColor: theme.palette.neutrals.main,
            lineWidth: 1.48,
            labels: {
                useHTML: true,
                style: {
                    fontSize: "12px",
                    color: theme.palette.text.primary,
                    textAlign: "center",
                },
            },
        },
        yAxis: {
            gridLineWidth: 0,
            tickInterval: 20,
            title: {
                text: undefined,
            },
            labels: {
                style: {
                    color: theme.palette.text.secondary,
                    fontSize: "12px",
                    fontWeight: "semibold",
                },
                formatter: function (this: any) {
                    if (this.value === 0) {
                        return `<span style="font: 16px 'Lucida Sans Unicode'; color: ${theme.palette.neutrals.main};">${this.value}</span>`;
                    } else {
                        return `${this.value}`;
                    }
                },
            },
        },
        legend: {
            enabled: false,
        },
        tooltip: {
            enabled: false,
        },
        series: chartDataState.series,
        plotOptions: {
            series: {
                lineWidth: 1.3,
                dashStyle: "ShortDash",
            },
            waterfall: {
                lineColor: theme.palette.neutrals.main,
            },
        },
        exporting: {
            menuItemDefinitions: {
                downloadPNG: { text: "Download PNG Image" },
                downloadSVG: { text: "Download SVG Image" },
            },
            buttons: {
                contextButton: {
                    menuItems: ["downloadPNG", "downloadSVG"],
                },
            },
            allowHTML: true,
            chartOptions: {
                chart: {
                    marginBottom: 65,
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                    },
                },
            },
        },
    };
};
